import ApplicationSerializer from './application';

type ScanSnapshot = {
  record: { isNew: boolean };
  adapterOptions?: { repositories?: unknown[] };
};

type SerializedScan = {
  data: { attributes?: Record<string, unknown> };
};

/**
 * The API merges `repositories` in a PATCH by key rather than replacing the
 * stored list, so an update only sends the entries the caller changed:
 * `scan.save({ adapterOptions: { repositories: [entry] } })`. Any other update
 * leaves `repositories` out. Sending the whole list on every save re-queued
 * every PENDING repo per request and overwrote statuses the clone callback
 * had written since the page last loaded. Creating a scan still sends the
 * full list.
 */
export default class ScanSerializer extends ApplicationSerializer {
  serialize(snapshot: ScanSnapshot, options: unknown): SerializedScan {
    // @ts-expect-error the application serializer is typed without `serialize`
    const json = super.serialize(snapshot, options) as SerializedScan;
    if (snapshot.record.isNew || !json.data.attributes) return json;

    const changedRepositories = snapshot.adapterOptions?.repositories;
    if (changedRepositories) {
      json.data.attributes['repositories'] = changedRepositories;
    } else {
      delete json.data.attributes['repositories'];
    }
    return json;
  }
}
